module.exports = __webpack_public_path__ + "static/media/creativ4.af3b86b7.jpg";